import React,{useState} from 'react'
import { message, Modal } from 'antd'
import { DropzoneArea } from 'material-ui-dropzone';

import { url , header } from "../Constent/Constant";
import QuoteForm from './QuoteForm';

const GetQuoteForm = ({ image , imageID, UpdateImage }) => {
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [UpdateId, setUpdateId] = useState('')

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: UpdateId
            })
            setImageModal(false);
        }
    };

    const showImageModal = (id) => {
        setImageModal(true);
        setUpdateId(id)
    };

    const handleCancel = () => {
        setImageModal(false);
    };

    const OnFormFill = (ObjectData) => {
        if (ObjectData !== null) {
            fetch(`${url}/page/requestaquote`, {
                method: 'POST',
                body: JSON.stringify({
                    data: {
                        firstname: ObjectData.fName,
                        lastname: ObjectData.lName,
                        email: ObjectData.email,
                        phone: ObjectData.phone
                    }
                }),
                headers: header
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.message === 'Success') {
                        message.success('Thank You')
                    }
                })
        } else {
            console.error('Not fill Correctly')
        }
    }


    return (
        <div className='Commercial-Quote' id={'Quotes'} >
            <h2> Get a Quote </h2>
            <div className='Commercial-Section'>
                <div className='Commercial-left-box'>
                <i onClick={() => showImageModal(imageID)} className="far fa-edit Edit-btn"></i>
                    
                    <img src={`${url}/api/getFile${image}`} alt="Img" />
                </div>
                <div className='Commercial-right-box'>
                    <QuoteForm OnSubmit={OnFormFill} />
                </div>
            </div>
                {/* Update Image Modal */}
                <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>
        </div>

    )
}

export default GetQuoteForm
